import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=272d2c1f&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=272d2c1f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d2c1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272d2c1f')) {
      api.createRecord('272d2c1f', component.options)
    } else {
      api.reload('272d2c1f', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=272d2c1f&scoped=true", function () {
      api.rerender('272d2c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Badge.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Badge.vue
// module id = 9
// module chunks = 0